import View            from 'scripts/poppet/view';
import template        from './unitLocation.vue.html';
import { Vue }         from 'vue/defavue';
import LocationOptions from './model-location-options';

const channelNav = Bb.Radio.channel( 'nav' );

const UnitLocationView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template       : template,
	
	onDomRefresh() {
		let self = this;
		
		new Vue({
			el: '#location-div',

			bb() {
				return {
					model: self.options.model,
					searchResults: new LocationOptions(),
				};
			},
			data() {
				return {
					editingObject: '',
					hoveredIndex: null,
					hoveringSave: false,
				};
			},
			computed: {
				locationOptions() {
					if(this.editingObject !== null && this.editingObject !== '') {
						return this.searchResults.get('locations');
					} else {
						this.searchResults.set({locations: [], totalPages: 0, currentPage: null});
					}

					return [];
				},
				selectedItem() {
					if(this.locationsOptions) {
						return this.locationOptions[0];
					} else {
						return '';
					}
				},
				canSave() {
					return this.locationOptions.length > 0;
				},
				selectedIndex() {
					if(this.hoveredIndex !== null) {
						return this.hoveredIndex;
					}
					if( this.hoveringSave ) {
						return 0;
					} 
					return -1;
				},

			},
			methods : {
				search( page ) {
					this.searchResults.fetchLocations( this.editingObject, page );
				},
				
				mouseOver( index ) {
					this.hoveredIndex = index;
				},

				mouseLeave( index ) {
					if(this.hoveredIndex === index) {
						this.hoveredIndex = null;
					}
				},

				hoverSave( isHovering ){
					this.hoveringSave = isHovering;
				},

				getName( location ) {
					if(location){
						let name = location.name;
						let locationDescription = '';
						if(location.municipality) {
							locationDescription = location.municipality;
						}
						
						if(location.county && location.county !== location.municipality ) {
							if( locationDescription !== '') {
								locationDescription += ', ';
							}
							locationDescription += location.county;
						}
						
						if(locationDescription !== '') {
							name += ' (' + locationDescription + ')';
						}
						
						return name;
					}
					return '';
				},

				back() {
					channelNav.trigger('unit:control:settings', [self.options.unitId,]);
				},
				
				cancelEditing() {
					this.editingObject = null;
					this.searchResults.set({locations: []});
				},
				
				saveLine(line) {
					let location = line;
					this.cancelEditing();
					self.save(location);
				},
			}
		});
	},

	save: function( location ) {
		this.options.model.saveLocation(location);
	},

} );

export default UnitLocationView;